<template>
  <div>
    <!--条形码-->
    <ButtonGroup shape="circle">
      <Button type="primary" icon="md-checkmark" :disabled="tagCode" @click="isAllSelectCheck">全选</Button>
      <Button type="warning" icon="ios-folder-outline" :disabled="tagCode" @click="saveBarCode">保存</Button>
    </ButtonGroup>
    <Divider />
    <Form>
      <FormItem v-for="(item, index) in goodsItem" :key="index">
        <Row style="padding: 5px 0">
          <Col span="8">
            <Checkbox size="large" v-model="item.isSelect">{{item.color}} - {{item.size}}</Checkbox>
          </Col>
          <Col span="8">
            <Input v-model="item.barcode" @on-keyup="changeBarcode(item)"></Input>
          </Col>
          <Col span="3" offset="1">
            <InputNumber :min="1" style="width: 100%"></InputNumber>
          </Col>
          <Col span="2" offset="1">
            <Button type="primary">
              <Icon type="md-qr-scanner" />
            </Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      cid: "",
      sid: localStorage.getItem("sid"),
      shop: localStorage.getItem("shop"),
      isAllSelectCheckBox: false,
      colourGroup: this.$store.state.AddCommodity.colourGroup,
      sizeGroup: this.$store.state.AddCommodity.sizeGroup,
      barCodeList: []
    };
  },
  props: {
    goodsItem: {
      type: Array,
      default: []
    },
    tagCode: {
      type: String,
      tagCode: null
    }
  },
  mounted: function() {
    //DOM更新完后再请求数据
    this.$nextTick(function() {
       
    });
  },
  created: function() {
    //DOM更新完之前请求数据
    let data = JSON.parse(localStorage.getItem("adminUser"));
    this.cid = data.cid;
  },
  methods: {
    isAllSelectCheck() {
      this.goodsItem.forEach(val => {
        val.isSelect = !val.isSelect;
      });
      this.$forceUpdate();
    },
    changeBarcode(value){
      value.barcode = value.barcode.replace(/[\u4E00-\u9FA5]/g,'')
      value.barcode = value.barcode.replace(/:/g,'')
      value.dataCode = value.dataCode.replace(/：/g,'')
    },
    saveBarCode() {
      let updateData = [];
      let barCodeSetting = [];
      this.goodsItem.forEach(ele => {
        if (ele.isSelect && ele.barcode) {
          if (ele.barcode.indexOf(":") == -1) {
            updateData.push({
              id: ele.id,
              barcode: "c" + this.sid + "|" + ele.barcode
            });
            barCodeSetting.push({
              colorid: ele.colorid,
              sizeid: ele.sizeid,
              barcode: "c" + this.sid + "|" + ele.barcode
            });
          } else {
            updateData.push({
              id: ele.id,
              barcode: ele.barcode
            });
            barCodeSetting.push({
              colorid: ele.colorid,
              sizeid: ele.sizeid,
              barcode: ele.barcode
            });
          }
        }
      });
      if (updateData.length <= 0) {
        this.$Message.error("请选择要修改的单品条形码");
        return;
      }
      this.$Api
        .updateBarCode({
          StockItems: JSON.stringify(updateData),
          isCreate: this.shop.iscreatebarcode || 0,
          sid: this.sid
        })
        .then(res => {
          if (res.code == 200) {
            this.$store.commit("setBarCodeSetting", barCodeSetting);
            this.$Message.success(res.msg);
          }
        })
        .catch(err => {
          this.$Message.error(err.msg);
        });
    }
  }
};
</script>


<style lang="scss" scoped>
</style>